module.exports = __webpack_public_path__ + "71cb97ad45675f64a3d4e03df3e59e3b.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/815.png
// module id = 1718
// module chunks = 2